module.exports = __webpack_public_path__ + "assets/img/kv-62569322.jpg";